export const Role = {
  HOST: "HOST",
  USER: "USER",
  GUEST: "GUEST",
};
